/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { VariantSimpleFilterEntitySchemaMode } from './variantSimpleFilterEntitySchemaMode';

/**
 * SimpleFilterEntitySchema for fields whose chips may carry `variants`.
 */
export interface VariantSimpleFilterEntitySchema {
  text: string;
  required?: boolean;
  mode?: VariantSimpleFilterEntitySchemaMode;
  variants?: string[] | null;
}
